<div class="dialog-wrapper">
  <h2 *ngIf="isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarLinkPost.createTitle" | translate }}
  </h2>
  <h2 *ngIf="!isNewPost" mat-dialog-title>
    {{ "brand.campaign.contentCalendarLinkPost.updateTitle" | translate }}
  </h2>
  <mat-dialog-content>
    <form [formGroup]="form">
      <div class="post-link-wrap">
        <div class="post-link-wrap-protocol">https://</div>
        <mat-form-field class="fieldset">
          <mat-label>{{
            "brand.campaign.contentCalendarLinkPost.linkPlaceholder" | translate
          }}</mat-label>
          <input matInput formControlName="postLink" name="postLink" required />
          <mat-error
            *ngIf="form.hasError('postLink', 'required')"
            class="invalid-link"
          >
            {{ "shared.requiredField" | translate }}
          </mat-error>

          <mat-error
            *ngIf="form.hasError('postLink', 'urlWithOptionalProtocol')"
            class="invalid-link"
          >
            {{ "shared.enterValidUrl" | translate }}
          </mat-error>

          <mat-error
            *ngIf="form.hasError('postLink', 'noUrlProtocol')"
            class="invalid-link"
          >
            {{ "shared.noNeedUrlProtocol" | translate }}
          </mat-error>
        </mat-form-field>
      </div>
      <h3>
        {{ "brand.campaign.contentCalendarLinkPost.image" | translate }}
        <app-tooltip
          text="{{
            'brand.campaign.contentCalendarLinkPost.imageToolTip' | translate
          }}"
        />
      </h3>
      <img *ngIf="imageUrl" class="item-img" [src]="imageUrl" />
      <div class="progress" *ngIf="loadingMetadata">
        <mat-progress-bar
          [color]="'accent'"
          class="progress-bar"
          mode="indeterminate"
        />
      </div>
      <app-brand-campaign-content-form-post-suggested-text
        *ngIf="postTags"
        #suggestedText
        (textChanged)="setPostText($event)"
        [text]="postText"
        [type]="campaign.type"
        [postTags]="postTags"
        [disableCampaignUniqueUrlWarning]="true"
        [maxLength]="150"
      />
    </form>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      class="btn btn--transparent"
      tabindex="-1"
      [mat-dialog-close]="true"
    >
      {{ "shared.cancel" | translate }}
    </button>
    <button
      class="btn btn--primary"
      tabindex="-1"
      (click)="onSaveContent()"
      [disabled]="isSaveDisabled"
    >
      <span *ngIf="saving">{{ "shared.saving" | translate }}</span>
      <span *ngIf="!saving">{{ "shared.save" | translate }}</span>
    </button>
  </mat-dialog-actions>
</div>
